<ng-container *transloco="let t;">
    <div class="form-group mb-0 d-flex justify-content-start align-items-center docStatusfilter">
        <label class="font-small-3 font-weight-500 mb-0 me-25" for="customSelect">{{ t('Status column - label (general) - status')}} </label>
        <ng-select
        [items]="statusesList$ | async"
        bindValue="value"
        bindLabel="name"
        groupBy="group"
        [ngModel] = 'filterByStatus$ | async'
        (change)="selectStatusFilter($event)"
        [placeholder]="t('Document - listview - filters - All')">
        </ng-select>
    </div>
</ng-container>
